import { Component, computed, EventEmitter, inject, Input, Output, signal, Signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Aenderung, HandelsgeschaeftService, SimpleHgType } from 'lion-api';
import { InvestmentService, TrackingIdService, TradeTransactionStore } from '@shared/data';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-betrag',
  templateUrl: './form-betrag.component.html',
  styleUrl: './form-betrag.component.scss',
  standalone: false
})
export class FormBetragComponent {
  @Input() attachForm?: FormGroup;
  @Input() renderAenderungsFeld = false;
  @Input() renderAufloesenButton = false;
  @Input() maskDisabled = false;
  @Input() availableChangeOptions: Signal<{ label: string; value: string }[]> = signal([]);

  @Output() nominalEmitter = new EventEmitter<string>();

  availableCurrencies: { code: string }[] = [{ code: 'EUR' }];

  private tradeTransactionStore = inject(TradeTransactionStore);
  private tradeTransaction = this.tradeTransactionStore.tradeTransaction;

  private handelsgeschaeftService = inject(HandelsgeschaeftService);
  private trackingService = inject(TrackingIdService);
  private confirmationService = inject(ConfirmationService);
  private translateService = inject(TranslateService);
  private investmentService = inject(InvestmentService);

  protected reducable = computed(() => {
    const aktuellerBestand = this.tradeTransaction()?.aktuellerBestand;
    return this.renderAufloesenButton && aktuellerBestand != null && aktuellerBestand > 0;
  });

  notifyParent() {
    const nominalValue = this.attachForm?.get('nominal')?.value;
    this.nominalEmitter.emit(nominalValue);
  }

  closeCallMoney() {
    const tradeTransaction = this.tradeTransaction();
    if (
      tradeTransaction != null &&
      tradeTransaction.typ != null &&
      tradeTransaction.typ.simpleHgType == SimpleHgType.Tagesgeld &&
      tradeTransaction.aktuellerBestand != null
    ) {
      tradeTransaction.betrag = tradeTransaction.aktuellerBestand;
      tradeTransaction.aenderung = Aenderung.Reduzieren;
      tradeTransaction.latestChange = 'betrag';

      this.handelsgeschaeftService.handelsgeschaeftCheckPost(this.trackingService.generateTrackingId(), tradeTransaction).subscribe({
        next: (response) => {
          const responseTradeTransaction = response.handelsgeschaeft;
          if (responseTradeTransaction) {
            this.tradeTransactionStore.updateTradeTransaction(tradeTransaction);

            this.attachForm?.patchValue({
              nominal: response.handelsgeschaeft?.betrag,
              change: response.handelsgeschaeft?.aenderung
            });

            this.confirmationService.confirm({
              header: this.translateService.instant('investment.label.callMoney.dialog.closeCallMoney'),
              message: this.translateService.instant('investment.label.callMoney.dialog.detail', {
                currentBalance: responseTradeTransaction.aktuellerBestand?.toLocaleString('de-DE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }),
              acceptIcon: 'pi pi-check',
              rejectIcon: 'pi pi-times',
              acceptButtonStyleClass: 'column-gap-2',
              rejectButtonStyleClass: 'column-gap-2',
              rejectButtonProps: {
                severity: 'secondary'
              },
              acceptLabel: this.translateService.instant('investment.label.callMoney.dialog.confirm'),
              rejectLabel: this.translateService.instant('investment.label.callMoney.dialog.decline'),
              accept: () => {
                this.tradeTransactionStore.updateProcessingState(true);
                this.investmentService.processExecute(responseTradeTransaction, false, false, true);
              },
              reject: () => {
                responseTradeTransaction.neuerBestand = tradeTransaction.neuerBestand;
                this.tradeTransactionStore.updateTradeTransaction(responseTradeTransaction);
              }
            });
          }
        }
      });
    }
  }
}
